/* Product Form Submit Handler (Ajax) */

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super()
    
    this.formElement = this.querySelector('form');
    this.formElement.addEventListener('submit', this.onSubmitHandler.bind(this));

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-outer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-outer',
        section: 'cart-summary',
        selector: '.cart__summary-outer'
      },
      {
        id: 'cart-drawer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-drawer',
        section: 'cart-footer',
        selector: '.cart-drawer__footer'
      },
      {
        id: 'nav-inner',
        section: 'cart-nav-icon',
        selector: '.nav__link--cart'
      }
    ];
  }

  // onSubmitHandler(evt) {
  //   evt.preventDefault();

  //   const config = fetchConfig('javascript');
  //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
  //   delete config.headers['Content-Type'];

  //   const formData = new FormData(this.formElement);
  //   formData.append('sections', this.getSectionsToRender().map((section) => section.section));
  //   formData.append('sections_url', window.location.pathname);

  //   config.body = formData;
    
  //   fetch("/cart/add.json", config)
  //   .then(response => {
  //     if(response.ok) {
  //       return response.json();
  //     }
  //     throw new Error('Request Failed!');
  //   }, networkError => console.log(networkError.message)
  //   ).then((response) => {
  //     this.getSectionsToRender().forEach((section => {
  //       if (document.getElementById(section.id) != null && document.getElementById(section.id).querySelector(section.selector) != null || document.getElementById(section.id) != null) {
  //         const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  //         elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
  //         cartDrawerOpen();
  //       }
  //     }))
  //     updateHeatBeatBar()
  //   })
  //  .catch((e) => {
  //     console.error(e);
  //   })
  // }

  onSubmitHandler(evt) {
    evt.preventDefault();
  
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
  
    const formData = new FormData(this.formElement);
    const sections = this.getSectionsToRender().map((section) => section.section);
    const sectionsUrl = window.location.pathname;
  
    formData.append('sections', sections);
    formData.append('sections_url', sectionsUrl);
  
    config.body = formData;
  
    // Step 1: Add to cart
    fetch("/cart/add.json", config)
      .then(response => {
        if (response.ok) return response.json();
        throw new Error('Request Failed!');
      }, networkError => console.log(networkError.message))
  
      // Step 2: Run promo logic
      // .then(() => updateCartForPromotion())
  
      // Step 3: Re-fetch cart sections after promo update
      .then(() => {
        return fetch(`/?sections=${sections.join(",")}&sections_url=${sectionsUrl}`)
          .then((res) => res.json());
      })
  
      // Step 4: Update DOM
      .then((sectionHtml) => {
        this.getSectionsToRender().forEach((section => {
          const container = document.getElementById(section.id);
          if (!container) return;
  
          const inner = container.querySelector(section.selector) || container;
          inner.innerHTML = this.getSectionInnerHTML(sectionHtml[section.section], section.selector);
          cartDrawerOpen();
        }));
        updateHeatBeatBar();
      })
  
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
})

/* General Product Form Controls */

// selectVariant = (optionSelector) => {
// 	var productForm = optionSelector.closest('product-form'),
// 		optionPosition = optionSelector.closest('.product__options-row').dataset.position,
// 		optionCount = optionSelector.closest('.product__options-container').dataset.optioncount,
// 		availableOptionsTwo = optionSelector.closest('.product__options-container').dataset?.availableoptionstwo.split(', '),
// 		availableOptionsThree = optionSelector.closest('.product__options-container').dataset?.availableoptionsthree.split(', '),
// 		dataurl = optionSelector.closest('.product__options-container').dataset.url,
// 		hiddenOptions = productForm.querySelectorAll('#productFormSelector option'),
// 		submitBtn = productForm.querySelector('.product-form__submit');
  
// 	changeSelectedOption(optionSelector);
	  
// 	if(optionPosition == 1) {
// 		optionOneClicked(optionSelector, availableOptionsTwo, availableOptionsThree);
// 	} else if(optionPosition == 2) {
// 		optionTwoClicked(optionSelector, availableOptionsThree);
// 	} else {
// 		optionThreeClicked(optionSelector, availableOptionsThree);
// 	}
  
// 	if(optionCount == 1) {
// 		for(i=0; i < hiddenOptions.length; i++) {
// 		  selectedVariant = productForm.querySelector('#option-1 .selected').dataset.value;
// 		  hiddenOptions[i].removeAttribute('selected');
		  
// 		  if(hiddenOptions[i].innerHTML.replace(/\s/g, '').replaceAll('/', '') == selectedVariant.replace(/\s/g, '').replaceAll('/', '')) {
// 			if(hiddenOptions[i].hasAttribute('disabled')) {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.add('disabled');
// 			  submitBtn.innerText = 'Out Of Stock';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			} else {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.remove('disabled');
// 			  submitBtn.innerText = 'Add To Cart';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			}
// 		  }
// 		}
// 	} else if(optionCount == 2) {
// 		for(i=0; i < hiddenOptions.length; i++) {
// 		  selectedVariant = productForm.querySelector('#option-2 .selected').dataset.selected;
// 		  hiddenOptions[i].removeAttribute('selected');
		  
// 		  if(hiddenOptions[i].innerHTML.replace(/\s/g, '').replaceAll('/', '') == selectedVariant.replace(/\s/g, '').replaceAll('/', '')) {
// 			if(hiddenOptions[i].hasAttribute('disabled')) {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.add('disabled');
// 			  submitBtn.innerText = 'Out Of Stock';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			} else {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.remove('disabled');
// 			  submitBtn.innerText = 'Add To Cart';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			}
// 		  }
// 		}
// 	} else {
// 		for(i=0; i < hiddenOptions.length; i++) {
// 		  selectedVariant = productForm.querySelector('#option-3 .selected').dataset.selected;
// 		  hiddenOptions[i].removeAttribute('selected');
		  
// 		  if(hiddenOptions[i].innerHTML.replace(/\s/g, '').replaceAll('/', '') == selectedVariant.replace(/\s/g, '').replaceAll('/', '')) {
// 			console.log(hiddenOptions[i].innerText.replace(/\s/g, ''))
// 			if(hiddenOptions[i].hasAttribute('disabled')) {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.add('disabled');
// 			  submitBtn.innerText = 'Out Of Stock';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			} else {
// 			  hiddenOptions[i].setAttribute('selected', true);
// 			  submitBtn.classList.remove('disabled');
// 			  submitBtn.innerText = 'Add To Cart';
// 			  if(window.location.href != dataurl + '?variant=' + hiddenOptions[i].value) {
// 				window.history.replaceState({ }, '', dataurl + '?variant=' + hiddenOptions[i].value);
// 			  }
// 			}
// 		  }
// 		}
// 	}
//   }
  
//   changeSelectedOption = (optionSelector) => {
// 	var optionRow = optionSelector.closest('.product__options-row'),
// 		rowOptions = optionRow.querySelectorAll('.product__option-btn');
  
// 	for(i=0; i < rowOptions.length; i++) {
// 		rowOptions[i].classList.remove('selected');
// 	}
// 	optionSelector.classList.add('selected');
//   }
  
//   optionOneClicked = (optionSelector, availableOptionsTwo, availableOptionsThree) => {
// 	var productForm = optionSelector.closest('product-form'),
// 		optionTwoList = productForm.querySelectorAll('#option-2 .product__option-btn'),
// 		optionThreeList = productForm.querySelectorAll('#option-3 .product__option-btn');
  
// 	for(i=0; i < optionTwoList.length; i++) {
// 		optionTwoList[i].dataset.selected = optionSelector.dataset.value + optionTwoList[i].dataset.value;
// 		if(availableOptionsTwo.includes(optionTwoList[i].dataset.selected)) {
// 		  optionTwoList[i].classList.remove('disabled');
// 		} else {
// 		  optionTwoList[i].classList.add('disabled');
// 		}
// 	}
// 	for(i=0; i < optionThreeList.length; i++) {
// 		optionTwo = productForm.querySelector('#option-2 .selected').dataset.selected;
// 		optionThreeList[i].dataset.selected = optionTwo + optionThreeList[i].dataset.value;
// 		if(availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
// 			optionThreeList[i].classList.remove('disabled');
// 		} else {
// 			optionThreeList[i].classList.add('disabled');
// 		}
// 	}
//   }
  
//   optionTwoClicked = (optionSelector, availableOptionsThree) => {
// 	var productForm = optionSelector.closest('product-form'),
// 		optionThreeList = productForm.querySelectorAll('#option-3 .product__option-btn');
  
// 	for(i=0; i < optionThreeList.length; i++) {
// 		optionThreeList[i].dataset.selected = optionSelector.dataset.selected + optionThreeList[i].dataset.value;
// 		if(availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
// 			optionThreeList[i].classList.remove('disabled');
// 		} else {
// 			optionThreeList[i].classList.add('disabled');
// 		}
// 	}
//   }
  
//   optionThreeClicked = (optionSelector, availableOptionsThree) => {
// 	var productForm = optionSelector.closest('product-form'),
// 		optionThreeList = productForm.querySelectorAll('#option-3 .product__option-btn'),
// 		optionTwo = productForm.querySelector('#option-2 .selected').dataset.selected;
// 	for(i=0; i < optionThreeList.length; i++) {
// 		optionThreeList[i].dataset.selected = optionTwo + optionThreeList[i].dataset.value;
// 		if(availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
// 			optionThreeList[i].classList.remove('disabled');
// 		} else {
// 			optionThreeList[i].classList.add('disabled');
// 		}
// 	}
// }

/* Quick Add Popup Controls */

quickAddOpen = (btn) => {
  btn.closest('.product-card').querySelector('product-form').classList.add('is-open');
  btn.closest('.product-card').querySelector('.product__options-container-inner').classList.add('is-visible');
  btn.closest('.product-card').querySelector('.product-card__details-container').classList.add('quickadd-is-open');
}

quickAddClose = (btn) => {
  btn.closest('.product-card').querySelector('product-form').classList.remove('is-open');
  btn.closest('.product-card').querySelector('.quick-add__label--back').style.display = 'none';
  btn.closest('.product-card').querySelector('.product-card__details-container').classList.remove('quickadd-is-open');

  var productOptionContainers = document.querySelectorAll('.product__options-container-inner');
  productOptionContainers.forEach((container) => {
    container.classList.remove('is-visible');
  })
}

quickAddBack = (btn) => {
  var currentOptionContainer = btn.closest('.product-card').querySelectorAll('.product__options-container-inner.is-visible'),
      currentOptionContainer = currentOptionContainer[currentOptionContainer.length - 1];

  console.log(currentOptionContainer);
  currentOptionContainer.classList.remove('is-visible');
  if(currentOptionContainer.previousSibling.classList.contains('is-first')) {
    btn.style.display = 'none';
  }

}

quickAddController = (btn) => {
  var optionContainer = btn.closest('.product__options-container-inner');

  if(optionContainer.classList.contains('is-last')) {
    optionContainer.closest('form').querySelector('.product-form__submit').click();
    setTimeout(() => {
      quickAddClose(btn);
    }, 300)
  } else {
    optionContainer.nextSibling.classList.add('is-visible');
    optionContainer.closest('.product-card').querySelector('.quick-add__label--back').style.display = 'block';
  }
}

function updateCartForPromotion() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const total = cart.items_subtotal_price;
      const lastItem = cart.items[cart.items.length - 1];
      const promoKey = 'Contains';
      const promoValue = 'FREE INFRARED PATIO HEATER INCLUDED WITH THIS ORDER!';

      if (!lastItem) return Promise.resolve(); // ✅ Return a resolved promise

      const hasPromo = lastItem.properties && lastItem.properties[promoKey] === promoValue;
      const needsPromo = total > 49999;

      if (needsPromo && !hasPromo) {
        const newProps = { ...(lastItem.properties || {}) };
        newProps[promoKey] = promoValue;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lastItem.key,
            quantity: lastItem.quantity,
            properties: newProps
          })
        });
      }

      if (!needsPromo && hasPromo) {
        const newProps = { ...lastItem.properties };
        delete newProps[promoKey];

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lastItem.key,
            quantity: lastItem.quantity,
            properties: newProps
          })
        });
      }

      return Promise.resolve(); // ✅ Important: always return a promise
    })
    .catch(err => {
      console.error('Promotion update failed:', err);
      return Promise.resolve(); // Still resolve to avoid breaking the chain
    });
}